import { Box } from "@mui/material";

interface NowPlayingBarsProps {
  playing: boolean;
  size?: number;
  color?: string;
  label?: string;
}

const BAR_DELAYS = ["-0.9s", "-0.35s", "-0.6s"];

const RESTING_SCALE = [0.45, 0.8, 0.6];

export function NowPlayingBars({ playing, size = 14, color = "currentColor", label }: NowPlayingBarsProps) {
  return (
    <Box
      component="span"
      role={label ? "img" : undefined}
      aria-label={label}
      aria-hidden={label ? undefined : true}
      data-playing={playing}
      sx={{
        display: "inline-flex",
        alignItems: "flex-end",
        gap: `${Math.max(1, Math.round(size / 7))}px`,
        width: `${size}px`,
        height: `${size}px`,
        flexShrink: 0,
        "@keyframes nowPlayingBar": {
          "0%, 100%": { transform: "scaleY(0.3)" },
          "50%": { transform: "scaleY(1)" },
        },
      }}
    >
      {BAR_DELAYS.map((delay, index) => (
        <Box
          key={delay}
          component="span"
          sx={{
            flex: 1,
            height: "100%",
            borderRadius: "1px",
            backgroundColor: color,
            transformOrigin: "bottom",
            transform: `scaleY(${RESTING_SCALE[index]})`,
            animation: playing ? `nowPlayingBar 0.9s ease-in-out ${delay} infinite` : "none",
            "@media (prefers-reduced-motion: reduce)": { animation: "none" },
          }}
        />
      ))}
    </Box>
  );
}

export default NowPlayingBars;
